import { render, staticRenderFns } from "./ChannelCodeDetail.vue?vue&type=template&id=56c47de5&scoped=true&"
import script from "./ChannelCodeDetail.vue?vue&type=script&lang=js&"
export * from "./ChannelCodeDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChannelCodeDetail.vue?vue&type=style&index=0&id=56c47de5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c47de5",
  null
  
)

export default component.exports